import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {
  DateLessThanValidator,
  StartAndEndDateRequiredValidator,
} from 'src/app/shared/validators/date.validator';
import { LineupErrorStateMatcher } from 'src/app/shared/services/error-state-matcher.service';
import { HistoricalTeamWrite } from 'src/app/shared/models/team/historicalTeamWrite';
import { PersonDetailsService } from 'src/app/shared/services/person-details.service';
import { TeamHistory } from 'src/app/people/models/teamHistory';

@Component({
  selector: 'app-team-historical-add',
  templateUrl: './team-historical-add.component.html',
  styles: [],
})
export class TeamHistoricalAddComponent implements OnInit {
  historicalTeamForm: UntypedFormGroup;
  dateFormGroup: UntypedFormGroup;
  matcher = new LineupErrorStateMatcher();
  personId: string;
  teamHistory: TeamHistory;
  editFlag: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<TeamHistoricalAddComponent>,
    private personDetailsService: PersonDetailsService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.teamHistory = data.teamHistory;
    this.personId = data.personId;
  }

  ngOnInit() {
    this.editFlag = this.teamHistory ? true : false;

    this.dateFormGroup = this.formBuilder.group({
      startDate: this.editFlag ? this.teamHistory.dateRange.startDate : null,
      endDate: this.editFlag ? this.teamHistory.dateRange.endDate : null,
    });

    this.dateFormGroup.setValidators([
      DateLessThanValidator('startDate', 'endDate'),
      StartAndEndDateRequiredValidator('startDate', 'endDate'),
    ]);

    this.historicalTeamForm = this.formBuilder.group({
      teamName: [this.editFlag ? this.teamHistory.teamName : '', Validators.required],
      positionTitle: [this.editFlag ? this.teamHistory.positionTitle : '', Validators.required],
      dateGroup: this.dateFormGroup,
    });
  }

  manageHistoricalTeam() {
    const historicalTeamForm = this.historicalTeamForm.value;
    const dateForm = this.dateFormGroup.value;
    let model = new HistoricalTeamWrite();
    model.name = historicalTeamForm.teamName;
    model.positionTitle = historicalTeamForm.positionTitle;
    model.startDate = dateForm.startDate;
    model.endDate = dateForm.endDate;

    if (this.editFlag) {
      this.personDetailsService
        .editPersonHistoricalTeam(this.personId, this.teamHistory.id, model)
        .subscribe((historicalTeamRead) => {
          this.dialogRef.close(historicalTeamRead);
        });
    } else {
      this.personDetailsService
        .createPersonHistoricalTeam(this.personId, model)
        .subscribe((historicalTeamRead) => {
          this.dialogRef.close(historicalTeamRead);
        });
    }
  }
}
